module.exports = __webpack_public_path__ + "img/Location.bfb5cc92.svg";